export default __webpack_public_path__ + "static/media/cloud_animation.b148fe4c.PNG";